import React, { useContext } from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { ArrowUpRight } from 'lucide-react';
import { AddressSearchContext } from '/src/App';
import './style.css';

const SECTION_HEADER = "Available Discounts + Offers";

const ProjectCardDiscounts = ({ project }) => {

    // Get the portalData from the AddressSearchContext
    const { portalData } = useContext(AddressSearchContext);

    // Load the companies, discounts, and icons from portalData
    const companies_local_storage = portalData.companies || [];
    const discounts_local_storage = portalData.discounts || [];
    const icons_local_storage = portalData.icons || {};
    
    // Get the discount ids from the project
    const discount_ids = project.project_discounts_master;

    // Filter the discounts in local storage to only ones with id that is in discount_ids
    const discounts = discounts_local_storage.filter(discount => discount_ids.includes(discount.id));

    // Aggregate the objects in the company_discounts array within the discounts array
    const company_discounts = discounts.map(discount => discount.company_discounts).flat();
    const total_discounts = company_discounts.length;


    // Enrich company_discounts with company information
    const enriched_company_discounts = company_discounts.map(discount => {
        // Find matching company from companies_local_storage
        const company = companies_local_storage.find(
            company => company.id === discount.entity_id
        );

        // If company exists, add its information to the discount object
        if (company) {
            return {
                ...discount,
                company_type: company.company_type,
                company_name: company.name,
                company_url: company.company_url,
                company_icon: icons_local_storage[company.icon] || null
            };
        }
        return discount;
    });

    console.log('Enriched discounts:', enriched_company_discounts);

    // Create the intro sentence
    let intro_sentence;
    if (total_discounts > 0) {
        intro_sentence = `Get news! We've found ${total_discounts} discounts you may be able to take advantage of. Remember, your resilience benefits these companies and they'll fight over you. Add this project to your Taking Action hub and we can help you get the best deals.`;
    } else {
        intro_sentence = `Unfortunately we don't currently see any discounts available for this project. However, add it to your Take Action hub and you'll be notified when new discounts are found and we can ensure you get the best deals!`;
    }

    const formatBenefitText = (discount, companyType) => {
        const isInsurance = companyType === "Insurance";
        const suffixText = isInsurance ? "Est. Premium Discount" : "Off";

        switch (discount.discount_value_type) {
            case "est_discount_percentage":
                return {
                    value: `${(discount.est_discount_percentage * 100).toFixed(0)}%`,
                    suffix: suffixText
                };
            case "est_discount_dollars":
                return {
                    value: `$${discount.est_discount_dollars.toLocaleString()}`,
                    suffix: suffixText
                };
            default:
                return { value: "", suffix: "" };
        }
    };

    return (
        <div className="project-card-section-container">
            <div className="project-card-section-header-frame">
                <h2 className="project-card-section-header box-shadow-standard">{SECTION_HEADER}</h2>
                <p className="project-card-section-intro-sentence text-align-center" dangerouslySetInnerHTML={{ __html: intro_sentence }} />
            </div>

            {total_discounts > 0 && (
                <div className="discount-cards-container">
                    {enriched_company_discounts.map((discount, index) => {
                        const benefit = formatBenefitText(discount, discount.company_type);

                        return (
                            <div key={index} className="discount-card">
                                <div className="discount-icon-container">
                                    <img
                                        src={CreateCloudfrontUrl(discount.company_icon)}
                                        alt={`${discount.company_name} logo`}
                                        className="discount-company-icon"
                                    />
                                </div>
                                <div className="discount-benefit">
                                    <span className="benefit-value">{benefit.value}</span>
                                    <span className="benefit-suffix">{benefit.suffix}</span>
                                </div>
                                <a
                                    href={discount.company_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="discount-learn-more box-shadow-standard"
                                >
                                    Learn More
                                    <ArrowUpRight size={16} />
                                </a>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default ProjectCardDiscounts;